import { App } from "./App";

export class HAApp extends App {

    public getQMenu() {
        if (this.has("qmenu")) {
            return super.getQMenu();
        }
        if (this.hasNavigation()) {
            return this.getNavigation().getQMenu();
        }
    }

    public hasNavigation() {
        return this.has("navigation");
    }

    public getNavigation() {
        return this.get("navigation");
    }
}
